import { render, staticRenderFns } from "./HDPadecimientosViewOnly.vue?vue&type=template&id=78065617&scoped=true"
import script from "./HDPadecimientosViewOnly.vue?vue&type=script&lang=js"
export * from "./HDPadecimientosViewOnly.vue?vue&type=script&lang=js"
import style0 from "./HDPadecimientosViewOnly.vue?vue&type=style&index=0&id=78065617&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78065617",
  null
  
)

export default component.exports